import mediumZoom from "medium-zoom"

up.compiler("#body", () => {
  mediumZoom("[data-zoom-src]")
})
